import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      return true;
    }

    // Token missing or already expired, send to login
    this.authService.forceLogout('/auth/login');
    return false;
  }
}
